// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM9 12V8H7V12H9ZM17 12V8H15V12H17ZM16.4684 14.7493L16.7177 13.7808L14.7808 13.2823L14.5316 14.2507C14.3566 14.9306 14.063 15.3307 13.7101 15.5769C13.3431 15.8331 12.8008 16 12 16H11V18H12C13.063 18 14.0487 17.7795 14.8547 17.217C15.6749 16.6446 16.1994 15.7946 16.4684 14.7493Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-crooked-smile-filled')
export default class CrookedSmileFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'crooked-smile-filled',
    }
  }
}
